import { getDiffTime } from '@/helpers/date';
import { LocalStorage } from '@/helpers/localStorage';

export interface PostgradFirstWeekBadgeStoredInfo {
  dismissed?: boolean;
}

export default class PostgradBadges {
  static localStorageKey = 'postgradBadges';

  static hasUserDismissedBadge(): boolean {
    const storedInfo = this.getStoredInfo();

    return !!storedInfo?.dismissed;
  }

  static shouldShowFirstWeekBadge(firstContentConsumedDate: Date | null): boolean {
    if (!firstContentConsumedDate) return false;

    const daysAfterFirstContentConsumption = getDiffTime(
      new Date().toJSON(),
      firstContentConsumedDate,
    ).days;

    return (
      daysAfterFirstContentConsumption >= 7 &&
      daysAfterFirstContentConsumption <= 12 &&
      !this.hasUserDismissedBadge()
    );
  }

  static getStoredInfo(): PostgradFirstWeekBadgeStoredInfo | null {
    return LocalStorage.get<PostgradFirstWeekBadgeStoredInfo>(this.localStorageKey);
  }

  static storeInfo(key: keyof PostgradFirstWeekBadgeStoredInfo, value: any): void {
    const storedInfo = this.getStoredInfo();

    const updatedStoredInfo = { ...storedInfo, [key]: value };

    LocalStorage.set(this.localStorageKey, updatedStoredInfo);
  }
}
